import { LoadingButton } from "@mui/lab";
import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  downloadReport,
  getJobsData,
  makePayment,
} from "../../features/jobs/jobs";
import { AppType, getRole, Roles } from "../../utils/helper";

// import React from "react";

const InspectJob = ({ data, refresh, appType }) => {
  const dispatch = useDispatch(),
    { modal } = useSelector(getJobsData);

  const makePayments = async (e) => {
    e.preventDefault();
    const res = await dispatch(
      makePayment({
        isBulk: false,
        medium: "ACCOUNT",
        accountIds: [data?.AcctRefID],
      })
    ).unwrap();
    res?.success && refresh?.();
  };

  return (
    <Box component="form" noValidate onSubmit={makePayments}>
      <div className="flex justify-between flex-wrap w-full">
        <p className="font-[600]">Account Name</p>
        <p>{data?.AcctName}</p>
      </div>

      <br />
      {AppType.cav === appType ? (
        <>
          <div className="flex justify-between flex-wrap w-full">
            <p className="font-[600]">Customer Address</p>
            <p>{data?.AcctAddress}</p>
          </div>

          <br />
          <div className="flex justify-between flex-wrap w-full">
            <p className="font-[600]">Updated Address</p>
            <p>{data?.UpdatedAcctAddress || "N/A"}</p>
          </div>

          <br />
          <div className="flex justify-between flex-wrap w-full">
            <label htmlFor="" className="font-[600]">
              Address Description
            </label>
            <p>{data?.AddressDescription || "N/A"}</p>
          </div>

          <br />
          <div className="flex justify-between w-full">
            <p className="font-[600]">Proof of Landmark</p>
            <p>{data?.AddressVerificationPhotos?.length ? "Yes" : "No"}</p>
          </div>

          {data?.AddressVerificationPhotos?.length > 0 && (
            <>
              <br />
              <div className="">
                <p className="font-[600] mb-4">Landmark images</p>
                <div className="flex">
                  {data?.AddressVerificationPhotos?.map((url, i) => (
                    <Link
                      href={url?.replaceAll('"', "")?.trim()}
                      alt={"landmark image " + i}
                      target="_blank"
                      rel="noreferrer"
                      download={false}
                    >
                      <img
                        key={i}
                        alt={i}
                        src={url?.replaceAll('"', "")?.trim()}
                        className="mr-4"
                        style={{
                          width: "109px",
                          height: "109px",
                          borderRadius: "5px",
                        }}
                      />
                    </Link>
                  ))}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div className="flex justify-between w-full">
            <p className="font-[600]">Customer RC Number</p>
            <p>{data?.RCNumber || "N/A"}</p>
          </div>

          <br />
          <div className="w-full">
            <p className="font-[600]">Solicitors' Report</p>
            {data?.SolicitorReport ? (
              <button
                onClick={() => dispatch(downloadReport(data?.SolicitorReport))}
                className="mt-2 flex items-end"
                type="button"
                disabled={modal.loader.download}
              >
                <span className="text-[#D70900] ml-1">
                  {" "}
                  {modal.loader.download
                    ? "Downloading..."
                    : "Download Solicitors' Report"}
                </span>
                {modal.loader.download && (
                  <CircularProgress
                    size="15px"
                    sx={{ color: "#D70900", margin: "5px" }}
                  />
                )}
              </button>
            ) : (
              <p>Not Available</p>
            )}
          </div>
        </>
      )}

      <br />
      <div className="flex justify-between w-full">
        <p className="font-[600]">
          {AppType.cav === appType ? "Vendor's" : "Solicitors'"} Comment
        </p>
        <p>{data?.CommentsVendor || "N/A"}</p>
      </div>

      <br />
      {[Roles.admin, Roles.superAdmin, Roles.bank].includes(getRole()) && (
        <div className="inline-block">
          <LoadingButton
            loading={modal.loader.confirm}
            type="submit"
            variant="contained"
            color="error"
            className="capitalize mr-1"
            style={{ textTransform: "capitalize", margin: "1em" }}
          >
            Mark as Paid
          </LoadingButton>
        </div>
      )}
    </Box>
  );
};

export default InspectJob;
